'use client'

import dynamic from 'next/dynamic'

import LazyMount from '@/components/LazyMount'

// Below-the-fold homepage sections, mounted on approach so their JS never
// lands in the first-load hydration budget (the mobile TBT/LCP ceiling).
// Text-critical sections (FAQ, pricing, blog) stay server-rendered in
// page.jsx — only the animation-heavy showpieces are deferred here.

function deferred(loader, minHeight) {
  const Section = dynamic(loader, {
    ssr: false,
    loading: () => <div style={{ minHeight }} aria-hidden />,
  })
  return function DeferredSection(props) {
    return (
      <LazyMount minHeight={minHeight}>
        <Section {...props} />
      </LazyMount>
    )
  }
}

export const ProductizedOfferBentoLazy = deferred(
  () => import('@/components/home/ProductizedOfferBento'),
  '80vh',
)
export const ScalingSuccessfulCompaniesLazy = deferred(
  () => import('@/components/home/ScalingSuccessfulCompanies'),
  '80vh',
)
export const SelectedWorkProofLazy = deferred(
  () => import('@/components/home/SelectedWorkProof'),
  '80vh',
)
export const KingdomComparisonLazy = deferred(
  () => import('@/components/home/KingdomComparison'),
  '80vh',
)
export const HomeTestimonialsLazy = deferred(
  () => import('@/components/home/HomeTestimonials'),
  '80vh',
)
export const FoundersDeskLazy = deferred(
  () => import('@/components/home/FoundersDesk'),
  '100vh',
)
